// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root_334YN","dropdown":"Dropdown_dropdown_3L4yk"};